import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Tab } from 'semantic-ui-react'
import { Button, Breadcrumb } from 'semantic-ui-react'
import { requestForQuotationPath } from 'routes'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import { MainBodyContent, K2ErrorModal } from 'components'
import RequestInfo from '../Form/RequestInfo'
import Summary from './Summary'
import General from '../Form/General'
import Detail from '../Form/Detail'
import Attachment from '../Form/Attachment'
import Approve from '../Form/Approve'
import ProcessHistory from './ProcessHistory'
import {
  initializeRFQ,
  getRFQDetail,
  getRFQGOAWorkFlowViewMode,
  clearRFQData,
  getRFQErrorWorkFlow,
  getGOAItem
} from 'ducks/rfq'
import { getProjectByCompany } from 'ducks/goa'
import { getPurchaseUsers } from 'ducks/member'
import { RFQStdCont } from '../styled'

const RFQDetail = props => {
  const {
    sapDetails,
    handleSubmit,
    history,
    k2workFlowError, 
    isDetail = true
  } = props

  useEffect(() => {
    props.initializeRFQ(isDetail)
    const { match: { params } } = props
    if (params && params.rfqId) {
      props.getRFQDetail(params.rfqId)
    }
    return (() => {
      props.clearRFQData()
    })
  }, [])

  useEffect(() => {
    if (sapDetails) {
      props.getGOAItem(sapDetails.companyCode, sapDetails.amountAfterDiscount, sapDetails.currencyCode)
    }
  }, [(sapDetails && sapDetails.amountAfterDiscount)])

  useEffect(() => {
    if (sapDetails && sapDetails.companyCode) {
      if (props.projects[sapDetails.companyCode] === undefined) {
        if (sapDetails.companyCode !== props.projectCompanyLoading) {
          props.getProjectByCompany(sapDetails.companyCode)
        }
      }
      props.getPurchaseUsers(sapDetails.companyCode, sapDetails.purchasingGroup)
    }
  }, [sapDetails && sapDetails.companyCode])

  useEffect(() => {
    if (sapDetails && sapDetails.status && sapDetails.status !== 0) {
      props.getRFQErrorWorkFlow(sapDetails.procInstId, sapDetails.subProcInstId)
    }
  }, [sapDetails && sapDetails.status])

  useEffect(() => {
    if (props.rfqId) {
      props.getRFQGOAWorkFlowViewMode(props.rfqId)
    }
  }, [props.rfqId])

  const panes = [
    { menuItem: 'Summary', render: () => <Summary /> },
    { menuItem: 'General', render: () => <General isDetail={isDetail} /> },
    { menuItem: 'Detail', render: () => <Detail valueForm={sapDetails} /> },
    { menuItem: 'Attachment', render: () => <Attachment /> },
    { menuItem: 'Comment History', render: () => <ProcessHistory /> },
  ]

  return (
    <MainBodyContent
      headerTitle={`Request for Quotation ${sapDetails ? ` - ${sapDetails.documentNumber || ''}` : ''}`}
      accessoriesHeader={
        sapDetails && sapDetails.urlPrintFormPo &&
        <Button
          basic
          circular
          type='button'
          content='View PO form'
          labelPosition='right'
          icon='clipboard list'
          onClick={() => (window.open(sapDetails.urlPrintFormPo, '_blank'))} />
      }
      breadcrumbs={
        <Breadcrumb
          icon='right angle'
          sections={[
            {
              key: 'RFQ',
              content: 'Request for Quotation',
              link: true,
              onClick: () => history.push(requestForQuotationPath),
            },
            { key: 'RFQDetail', content: 'Detail', active: true },
          ]}
        />
      }
      accessoriesHeaderLeft={
        k2workFlowError.isError && <K2ErrorModal checkK2Error={k2workFlowError} />
      }
    >
      <form>
        <RFQStdCont>
          {sapDetails && <DocumentStep documentDetail={sapDetails} approvers={props.goaWorkFlow.data} />}
          <RequestInfo change={props.change} />
          {sapDetails && sapDetails.sn && sapDetails.status !== 6 && !k2workFlowError.isError && <Approve history={history} handleSubmit={handleSubmit} rfqDetail={sapDetails} />}
          <Tab style={{ flex: 1, marginTop: '1rem' }} menu={{ attached: false }} panes={panes} />
        </RFQStdCont>
      </form>
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const projectCompanyLoading = state.goa.projectCompanyLoading
  const projects = state.goa.projects

  var sapDetails = state.rfq.sapDetails.data
  return {
    initialValues: {
      ...sapDetails,
    },
    rfqId: sapDetails ? sapDetails.id : null,
    sapDetails,
    projects,
    projectCompanyLoading,
    //valueForm: getFormValues('formRFQ')(state) || {},
    k2workFlowError: state.rfq.k2workFlowError,
    goaWorkFlow: state.rfq.goaWorkFlow,
  }
}

const mapDispatchToProps = {
  initializeRFQ,
  getProjectByCompany,
  getRFQDetail,
  getRFQGOAWorkFlowViewMode,
  clearRFQData,
  getRFQErrorWorkFlow,
  getPurchaseUsers,
  getGOAItem
}

const contForm = reduxForm({
  form: 'formRFQ',
  enableReinitialize: true,
})(RFQDetail)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
